export const FULL_DRAWER_WIDTH = 240
export const ICONS_ONLY_DRAWER_WIDTH = 56
export const APPBAR_HEIGHT = 80
